module.exports = __webpack_public_path__ + "img/trust-process5.ad7c5458.png";